import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Avatar, Tooltip, TableCell, Typography } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Label from 'src/components/label';

import { avatarStyle } from 'src/sections/groupUsers/style';

import {
  boxStyle,
  labelStyle,
  toolTipStyle,
  typographyStyle,
  typographyStyle2,
  typographyLabelStyle,
} from './style';

function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }
  return text;
}

function TagsCell({ tags }) {
  const { isSmallScreen } = useResponsiveScreen();
  const { t } = useTranslation();
  const maxLength = isSmallScreen ? 10 : 15;

  return (
    <TableCell
      align="left"
      sx={{
        fontSize: isSmallScreen && '0.65rem',
      }}
    >
      {tags.length > 0 ? (
        <>
          {tags.slice(0, 1).map((tag) => {
            const tagName = tag?.tag?.name || '';
            const tagValue = tag?.value || '';
            const truncatedName = truncateText(tagName, maxLength);
            const truncatedValue = truncateText(tagValue, maxLength);

            return (
              <Label key={tag?.id} sx={labelStyle}>
                <Tooltip title={tagName.length > maxLength ? tagName : ''}>
                  <Typography variant="subtitle2" sx={typographyLabelStyle}>
                    {truncatedName}
                  </Typography>
                </Tooltip>
                {' - '}
                <Tooltip title={tagValue.length > maxLength ? tagValue : ''}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: isSmallScreen ? '0.65rem' : '0.75rem',
                    }}
                  >
                    {truncatedValue}
                  </Typography>
                </Tooltip>
              </Label>
            );
          })}
          {tags.length > 1 && (
            <Tooltip
              title={
                <Box sx={boxStyle}>
                  {tags.slice(1).map((tag) => {
                    const tagName = tag?.tag?.name || '';
                    const tagValue = tag?.value || '';
                    const truncatedName = truncateText(tagName, maxLength);
                    const truncatedValue = truncateText(tagValue, maxLength);

                    return (
                      <Box key={tag?.id} sx={{ display: 'flex', gap: '0.25rem' }}>
                        <Tooltip title={tagName.length > maxLength ? tagName : ''}>
                          <Typography variant="subtitle2" sx={typographyStyle}>
                            {truncatedName}
                          </Typography>
                        </Tooltip>
                        {' - '}
                        <Tooltip title={tagValue.length > maxLength ? tagValue : ''}>
                          <Typography variant="body2" sx={typographyStyle2}>
                            {truncatedValue}
                          </Typography>
                        </Tooltip>
                      </Box>
                    );
                  })}
                </Box>
              }
              sx={toolTipStyle}
            >
              <Avatar
                sx={{
                  ...avatarStyle,
                  backgroundColor: 'grey.300',
                }}
              >
                <Typography
                  sx={{
                    color: 'black',
                    fontSize: isSmallScreen ? '0.65rem' : '0.75rem',
                  }}
                >
                  +{tags.length - 1}
                </Typography>
              </Avatar>
            </Tooltip>
          )}
        </>
      ) : (
        <Typography
          sx={{
            fontSize: isSmallScreen ? '0.65rem' : '0.8rem',
          }}
        >
          {t('pages.tagsPage.noTagsYet')}
        </Typography>
      )}
    </TableCell>
  );
}

TagsCell.propTypes = {
  tags: PropTypes.array,
};

export default TagsCell;
